import React, { useEffect, useContext } from "react"
import './404.scss';

const NotFoundPage = () => {
  return (<>404</>)
}

export default NotFoundPage
